import moment from 'moment';
import { useEffect, useState } from 'react';
import MarketOzonApi from '../../../../API/market/ozon-api';
import MarketWbApi from '../../../../API/market/wb-api';
import MarketYandexApi from '../../../../API/market/yandex-api';
import { Column, Row } from '../../../../components/Basic/Blocks';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../../components/Basic/Table';
import { Text, TextGrey } from '../../../../components/Basic/WrapsStyle';
import { formFullDate } from '../../../../utils';
import styles from './styles.module.scss';

const SHOPS_OZON = [
  { name: 'Озон 1', key: 'ozon1' },
  { name: 'Озон 2', key: 'ozon2' },
  { name: 'Озон 3', key: 'ozon3' },
  { name: 'Озон 4', key: 'ozon4' },
  { name: 'Озон 5', key: 'ozon5' },
  { name: 'Озон 6', key: 'ozon6' },
  { name: 'Озон 7', key: 'ozon7' },
];
const SHOPS_WB = [
  { name: 'Wildberries 1', key: 'wb1' },
  { name: 'Wildberries 2', key: 'wb2' },
  { name: 'Wildberries 3', key: 'wb3' },
  { name: 'Wildberries 4', key: 'wb4' },
  { name: 'Wildberries 5', key: 'wb5' },
  { name: 'Wildberries 6', key: 'wb6' },
  { name: 'Wildberries 7', key: 'wb7' },
];
const SHOPS_YANDEX = [
  { name: 'Яндекс 1', key: 'yandex1' },
  { name: 'Яндекс 3', key: 'yandex3' },
  { name: 'Яндекс 4', key: 'yandex4' },
  { name: 'Яндекс 5', key: 'yandex5' },
  { name: 'Яндекс 6', key: 'yandex6' },
  { name: 'Яндекс 7', key: 'yandex7' },
  { name: 'Яндекс 2 Express', key: 'yandex2' },
  { name: 'Яндекс 8 Express', key: 'yandex8' },
];

const SHOPS_MM = [
  { name: 'СберМаркет 1', key: 'megamarket1' },
  { name: 'СберМаркет 2', key: 'megamarket2' },
];

const MAP_SHOPS = {
  ozon1: 'B-WHITE',
  ozon2: 'B-MAX',
  ozon3: 'OZON-3',
  ozon4: 'OZON-4',
  ozon5: 'OZON-5',
  ozon6: 'OZON-6',
  ozon7: 'OZON-7',
  yandex1: 'B-WHITE',
  yandex2: 'B-MAX',
  yandex3: 'U-RURU',
  yandex4: 'YANDEX-4',
  yandex5: 'YANDEX-5',
  yandex6: 'YANDEX-6',
  yandex7: 'YANDEX-7',
  yandex8: 'YANDEX-8',
  wb1: 'B-WHITE',
  wb2: 'B-MAX',
  wb3: 'U-RURU',
  wb4: 'WB-4',
  wb5: 'WB-5',
  wb6: 'WB-6',
  wb7: 'WB-7',
  megamarket1: 'B-WHITE',
  megamarket2: 'B-MAX',
};
const MAP = {
  Ozon: SHOPS_OZON,
  Wildberries: SHOPS_WB,
  ЯндексМаркет: SHOPS_YANDEX,
  МегаМаркет: SHOPS_MM,
};

const CALLBACK_PRICE_STOCKS = {
  ['Ozon']: MarketOzonApi.updateStocksAndPrices,
  ['Wildberries']: MarketWbApi.updateStocks,
  ['ЯндексМаркет']: MarketYandexApi.updateStocks,
  // ['МегаМаркет']: updateMegamarketStocksAndPricesByProvider,
};
const CALLBACK_PRICE = {
  // ['Ozon']: updateOzonPricesByProvider,
  ['Wildberries']: MarketWbApi.updatePrices,
  ['ЯндексМаркет']: MarketYandexApi.updatePrices,
  // ['МегаМаркет']: updateMegamarketPricesByProvider,
};

let MAP_NAME = {
  load_cards: 'Выгрузка карточек',
  load_prices: 'Выгрузка цен',
  load_stocks_mp: 'Выгрузка остатков на складе МП',
};
const width = ['80px', '150px', '200px', '100px', '100px', '60px', '150px', '180px', '200px', '250px', '50px'];

const MarketsUpdateTable = ({
  providers = [],
  market,
  state,
  updateStatuses = () => { },
  skladName,
  data = [],
  mode,
  ...props
}) => {
  const [select, setSelect] = useState([]);

  console.log(market, select);
  useEffect(() => {
    setSelect(MAP[market] || []);
  }, [market]);

  const isPrice = state === 'Цена';
  const key = isPrice ? 'price' : 'stock';


  return (
    <>
      <Table styles={styles.ozon_table}>
        <TableHeader whiteHeader={true} styles={styles.table_line}>
          <HeaderTitle width={width[1]}>Поставщик</HeaderTitle>
          {select.map((market) => (
            <HeaderTitle width={width[2]} centerText={true} key={market.name}>
              {market.name}
            </HeaderTitle>
          ))}
        </TableHeader>
        {data.length > 0 &&
          ['load_cards', 'load_prices', 'load_stocks_mp'].map((key, id) => {
            let item = 1;

            return (
              <TableLine key={`${key}-${id}`} styles={styles.table_line}>
                <TableCell width={width[1]}>
                  <Column>{MAP_NAME[key]}</Column>
                </TableCell>
                {select.map((market) => {
                  let market_info = data?.find((item) => item.shop === market.key);
                  // console.log(data, market, market_info, key);
                  let market_data = market_info?.update_statuses[key];

                  const status = market_data.status;
                  const date = market_data.date;

                  const all = market_data.all;
                  const done = market_data.done;

                  const last_update = moment(date).fromNow();

                  //  console.log(provider, market, ((provider.markets_update || {})[market.key] || {})[key], last_update)

                  const calcDiff = (d) => {
                    const start = moment(d);
                    const now = moment();
                    let milisecond = now.diff(start);

                    return milisecond;
                  };

                  const diff = calcDiff(date);
                  const border = 54000000;
                  const border_3_days = 259200000;

                  return (
                    <TableCell width={width[2]} center={true} key={`${market.key}${key}`}>
                      <Row>
                        {status === 'loading' && (
                          <Column style={{ alignItems: 'center' }}>
                            <Text className={styles.loaded_text}>Обновляется</Text>
                            <Text style={{ color: '#ed3f2d', fontWeight: 600 }} fontWeight={600}>{`${Math.ceil(
                              (done / all) * 100,
                            )}%`}</Text>
                          </Column>
                        )}
                        {status === 'stopped' && (
                          <Column style={{ alignItems: 'center' }}>
                            <Text className={styles.stopped_text}>Остановлено</Text>
                            <Text style={{ color: '#106fdc', fontWeight: 600 }} fontWeight={600}>{`${Math.ceil(
                              (done / all) * 100,
                            )}%`}</Text>
                          </Column>
                        )}
                        {status === 'loaded' && (
                          <Column style={{ alignItems: 'center' }}>
                            <Text
                              className={
                                diff > border_3_days
                                  ? styles.red_text
                                  : diff < border
                                    ? styles.green_text
                                    : styles.blue_text
                              }
                            >
                              {formFullDate(date)}
                            </Text>
                            <TextGrey fontSize={12}>{last_update === 'Invalid date' ? '' : last_update}</TextGrey>
                          </Column>
                        )}
                      </Row>
                    </TableCell>
                  );
                })}
              </TableLine>
            );
          })}
      </Table>
    </>
  );
};

export default MarketsUpdateTable;
